import { Box, CircularProgress } from "@mui/material"
import React, { useEffect, useState } from "react"
import { useCookies } from "react-cookie"
import { useDispatch, useSelector } from "react-redux"
import { Navigate, Route, Routes } from "react-router-dom"

import { Home } from "./pages/Home/Home"
import { Login } from "./pages/Login/Login"
import Organizations from "./pages/Organizations/Organizations"
import InternalRecycleAll from "./pages/Storage/InternalRecycleAll/InternalRecycleAll"
import Suscribers from "./pages/Subscriber/Subscriber"
import Users from "./pages/Users/Users"
import { loginSuccess } from "./redux/actions/User"
import {
  SnackBarError,
  SnackBarSuccess,
} from "./components/SnackBars/SnackBars"
import Menu from "./components/Menu/Menu"
import { Suborganization } from "./pages/Suborganizations/Suborganization"
import { ImportCVS } from "./pages/ImportCVS/ImportCVS"
import ApplicationInstances from "./pages/Instances/Instances"
import {
  getTokenValidateDate,
  getUserRoles,
  validate,
} from "./utils/validateToken"
import { GlobalNotification } from "./pages/GlobalNotification/GlobalNotification"
import { FeactureFlags } from "./pages/FeactureFlags/FeactureFlags"
import { Security } from "./pages/Security/Security"
import parser from "./utils/Parser"
import Declarations from "./pages/Declarations/Declarations"
import EVentanilla from "./pages/EVentanilla/EVentanilla"
import AutenticateModal from "./components/AutenticateModal/AutenticateModal"
import Clientes from "./pages/Clients/Clientes"
import AdminAccessUserApp from "./pages/Security/AdminAccessUserApp/AdminAccessUserApp"

function App() {
  const dispatch = useDispatch()
  const user = useSelector((state) => state.user)
  const [cookies, setCookies, removeCookie] = useCookies([
    "webcgi_JWT2",
    "syserrepar_JWT2",
  ])
  const [loading, setLoading] = useState(true)
  const [loaderAutenticate, setloaderAutenticate] = useState(false)
  const domain = parser.getDomain()

  const handleLogin = (token, setCookie = false) => {
    if (setCookie) {
      setCookies("webcgi_JWT2", token, { domain, path: "/" })
      removeCookie("syserrepar_JWT2", { domain: ".errepar.com" })
    }
    dispatch(loginSuccess(token))
  }

  const handleUserAuthentication = () => {
    const iswebCGIToken = !!(cookies.webcgi_JWT2 && cookies.webcgi_JWT2 !== "")
    const issyserreparToken = !!(
      cookies.syserrepar_JWT2 && cookies.syserrepar_JWT2 !== ""
    )

    if (iswebCGIToken && !issyserreparToken) {
      const authenticateWebCGI = validate(cookies.webcgi_JWT2)

      if (authenticateWebCGI.isExpired)
        return removeCookie("webcgi_JWT2", { domain })
      if (
        !authenticateWebCGI.isValidOrgAppAccess ||
        !authenticateWebCGI.isValidUserAppAccess
      ) {
        setloaderAutenticate(true)
        return removeCookie("webcgi_JWT2", { domain })
      }
      handleLogin(cookies.webcgi_JWT2)
    }

    if (!iswebCGIToken && issyserreparToken) {
      const authenticateToken = validate(cookies.syserrepar_JWT2)

      if (authenticateToken.isExpired)
        return removeCookie("syserrepar_JWT2", { domain: ".errepar.com" })
      if (
        !authenticateToken.isValidOrgAppAccess ||
        !authenticateToken.isValidUserAppAccess
      ) {
        setloaderAutenticate(true)
        return removeCookie("syserrepar_JWT2", { domain: ".errepar.com" })
      }
      if (authenticateToken.isValidApplication)
        return handleLogin(cookies.syserrepar_JWT2, true)
    }

    if (iswebCGIToken && issyserreparToken) {
      const authenticateWebCGI = validate(cookies.webcgi_JWT2)
      const authenticateToken = validate(cookies.syserrepar_JWT2)

      if (authenticateWebCGI.isExpired) removeCookie("webcgi_JWT2", { domain })
      if (authenticateToken.isExpired)
        removeCookie("syserrepar_JWT2", { domain: ".errepar.com" })

      if (cookies.syserrepar_JWT2 && cookies.webcgi_JWT2) {
        if (authenticateToken.isValidApplication) {
          const newToken = getTokenValidateDate(
            cookies.webcgi_JWT2,
            cookies.syserrepar_JWT2,
          )
          const authenticateNewToken = validate(newToken)

          if (
            !authenticateNewToken.isValidOrgAppAccess ||
            !authenticateNewToken.isValidUserAppAccess
          ) {
            setloaderAutenticate(true)
            removeCookie("syserrepar_JWT2", { domain: ".errepar.com" })
            removeCookie("webcgi_JWT2", { domain: ".errepar.com" })
            return
          }
          return handleLogin(newToken, true)
        } else {
          return handleLogin(cookies.webcgi_JWT2, true)
        }
      } else {
        return handleUserAuthentication()
      }
    }
  }
  useEffect(async () => {
    setLoading(true)
    handleUserAuthentication()
    setLoading(false)
  }, [])

  return (
    <>
      <Box
        elevation={0}
        style={{
          margin: 0,
          height: "100vh",
          padding: 0,
        }}
      >
        {loading ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <CircularProgress />
          </Box>
        ) : user.eAuthToken ? (
          <Box style={{ display: "flex", backgroundColor: "#F2F2F2" }}>
            <Menu />
            <SnackBarSuccess />
            <SnackBarError />
            <Routes>
              <Route path="home" element={<Home />} />
              <Route path="organizations/*" element={<Organizations />} />
              <Route path="subscribers/*" element={<Suscribers />} />
              <Route path="users/*" element={<Users />} />
              <Route path="suborganizations/*" element={<Suborganization />} />
              <Route path="security/*" element={<Security />} />
              <Route
                path="storage/recycle/*"
                element={<InternalRecycleAll />}
              />
              {(getUserRoles(user.eAuthToken).includes(
                "CGI.GlobalNotificationAdmin",
              ) ||
                getUserRoles(user.eAuthToken).includes(
                  "CGI.GlobalNotificationInfoOperator",
                ) ||
                getUserRoles(user.eAuthToken).includes(
                  "CGI.GlobalNotificationReader",
                )) && (
                <Route
                  path="globalNotification/*"
                  element={<GlobalNotification />}
                />
              )}

              {(getUserRoles(user.eAuthToken).includes(
                "CGI.GlobalAppAccessAdmin",
              ) ||
                getUserRoles(user.eAuthToken).includes(
                  "CGI.GlobalAppMaintainer",
                ) ||
                getUserRoles(user.eAuthToken).includes(
                  "CGI.MeAppAccessAdmin",
                ) ||
                getUserRoles(user.eAuthToken).includes(
                  "CGI.CgiAppAccessAdmin",
                ) ||
                getUserRoles(user.eAuthToken).includes(
                  "CGI.CmAppAccessAdmin",
                ) ||
                getUserRoles(user.eAuthToken).includes(
                  "CGI.PerAppAccessAdmin",
                )) && (
                <Route
                  path="/admin-access-user-app-content/*"
                  element={<AdminAccessUserApp />}
                />
              )}
              {getUserRoles(user.eAuthToken).includes("CGI.Admin") && (
                <>
                  <Route path="ME" element={<ApplicationInstances />} />
                  <Route path="ME/import-cvs" element={<ImportCVS />} />
                  <Route
                    path="ME/applicationInstances/*"
                    element={<ApplicationInstances />}
                  />
                  <Route
                    path="ME/feacture-flags/*"
                    element={<FeactureFlags />}
                  />
                  <Route path="ME/eventanilla/*" element={<EVentanilla />} />
                  <Route path="ME/declarations/*" element={<Declarations />} />
                  <Route
                    path="globalNotification/*"
                    element={<GlobalNotification />}
                  />
                  <Route path="ME/clientes/*" element={<Clientes />} />
                  <Route
                    path="/admin-access-user-app-content/*"
                    element={<AdminAccessUserApp />}
                  />
                </>
              )}

              {getUserRoles(user.eAuthToken).includes(
                "CGI.CustomerSupport",
              ) && (
                <>
                  <Route path="ME" element={<ApplicationInstances />} />
                  <Route path="ME/import-cvs" element={<ImportCVS />} />
                  <Route
                    path="ME/applicationInstances/*"
                    element={<ApplicationInstances />}
                  />
                  <Route path="ME/declarations/*" element={<Declarations />} />
                </>
              )}

              {(getUserRoles(user.eAuthToken).includes("CGI.CustomerSupport") ||
                getUserRoles(user.eAuthToken).includes(
                  "CGI.LegalCommOperator",
                )) && (
                <>
                  <Route path="ME/eventanilla/*" element={<EVentanilla />} />
                  <Route
                    path="ME"
                    element={<Navigate replace to="/ME/eventanilla" />}
                  />
                </>
              )}

              {getUserRoles(user.eAuthToken).includes(
                "CGI.MeAppMaintainer",
                "CGI.GlobalAppMaintainer",
              ) && (
                <>
                  <Route
                    path="ME/feacture-flags/*"
                    element={<FeactureFlags />}
                  />
                  <Route
                    path="ME"
                    element={<Navigate replace to="/ME/feacture-flags" />}
                  />
                </>
              )}

              <Route path="*" element={<Navigate replace to="/home" />} />
            </Routes>
          </Box>
        ) : (
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="*" element={<Navigate replace to="/login" />} />
          </Routes>
        )}
      </Box>
      <AutenticateModal loaderAutenticate={loaderAutenticate} />
    </>
  )
}

export default App
